<template>
  <span @click.stop="liked(movie)">
    <svg :class="theme + ' ' + (like ? 'like' : '')" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 21.19">
      <path d="M960,549.84l-9.59-10a5.67,5.67,0,0,1-1.06-6.55h0a5.67,5.67,0,0,1,9.08-1.47l1.57,1.56,1.57-1.56a5.67,5.67,0,0,1,9.08,1.47h0a5.67,5.67,0,0,1-1.06,6.55Z" transform="translate(-948 -529.41)"/>
    </svg>
    <slot></slot>
  </span>
</template>

<script>
export default {
  props: ['theme', 'state', 'movie'],
  data () {
    return {
      like:false,
    }
  },
  methods: {
    liked:function(movie){
      if(movie) {
        //insert event to like the movie here
        this.like=!this.like;
      }
    }
  },
  created: function(){
    if(this.state) this.like = true;
  }
}
</script>

<style lang="scss" scoped>
@import '../../sass/variables';

span{
  cursor: pointer;
}

svg {
  height:1em;
  margin-bottom: -0.2em;
  margin-right:0.5em;
  width: auto;
  @include for-size(big-desktop-up) {
    height:1.25vw;
    margin-bottom: -0.2vw;
  }

  &.like {
    animation: .5s rubberBand ease;
    path {
      fill:#000;
    }
  }

  &.light{
    path {stroke:#000;}
    &.like {
      path {
        fill:#000;
      }
    }
  }

  &.dark{
    path {stroke:#fff;}
    &.like {
      path {
        fill:$like-pink;
        stroke:$like-pink;
      }
    }
  }

  path {
    fill:none;
    stroke:#000;
    stroke-linecap:round;
    stroke-linejoin:round;
    stroke-width:1.5px;
  }
}

@keyframes rubberBand {
  from {
    transform: scale3d(1, 1, 1);
  }

  30% {
    transform: scale3d(1.25, 0.75, 1);
  }

  40% {
    transform: scale3d(0.75, 1.25, 1);
  }

  50% {
    transform: scale3d(1.15, 0.85, 1);
  }

  65% {
    transform: scale3d(0.95, 1.05, 1);
  }

  75% {
    transform: scale3d(1.05, 0.95, 1);
  }

  to {
    transform: scale3d(1, 1, 1);
  }
}

</style>



// WEBPACK FOOTER //
// src/components/elements/FavoriteIcon.vue